<div class="timeline-container">
    <div class="card-time">
      <h4 *ngIf="timeline.seqTimeline">{{ timeline.dataHora | date:'HH:mm'}}
        <small>{{ timeline.dataHora | date:'dd/MM/yyyy'}}</small>
      </h4>
    </div>

    <div class="card-dot">
      <em class="fa fa-circle"></em>
    </div>

    <div class="panel card-panel">
      <div class="step">
        <div class="content">
          <span class="icon"></span>
          <h2>{{ timeline.tituloStatus }}</h2>
          <span *ngIf="timeline.subTituloStatus" [innerHTML]="subtitulo"></span>
        </div>

        <div *ngIf="timeline.finalizado" class="complemento">
          <div class="row" *ngIf="timeline.informacaoComplementar">
            <div class="col-xs-12">
                <div class="p descricao-complemento">
                    {{ timeline.informacaoComplementar?.descricao }}
                </div>
            </div>
          </div>
        </div>

        <div *ngIf="!timeline.finalizado" class="complemento blue">
            <div class="row">
              <div class="col-xs-12 title border-top">
                O Cliente é Alfabetizado?
              </div>
            </div>
            <div class="row bg-white">
              <div class="col-xs-12">
                <app-button-select [(ngModel)]="alfabetizado">
                  <app-button-select-item [value]="true" title="Sim" [disabled]="timeline.informacaoComplementar?.assinadoDigitalmente" (onSelect)="changeAlfabetizado($event)"></app-button-select-item>
                  <app-button-select-item [value]="false" title="Não" [disabled]="timeline.informacaoComplementar?.assinadoDigitalmente" (onSelect)="changeAlfabetizado($event)"></app-button-select-item>
                </app-button-select>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12" *ngIf="timeline.informacaoComplementar?.descricao">
                  <div class="p descricao-complemento">
                      {{ timeline.informacaoComplementar?.descricao }}
                  </div>
              </div>

              <div *ngIf="timeline.informacaoComplementar?.documentosPendentes" class="col-xs-12">
                  <app-upload-arquivos
                      buttonLabel="Enviar para formalização"
                      hideInfo="true"
                      [isOrigemSos]="false"
                      [hideSendButton]="assinaturaDigital && !timeline.informacaoComplementar?.assinadoDigitalmente"
                      [enableSendButton]="assinaturaDigital && timeline.informacaoComplementar?.assinadoDigitalmente"
                      [documentos]="documentosPendentes"
                      [idFicha]="proposta.id"
                      [cliente]="proposta.cliente"
                      [origem]="proposta.grupo2 === 'MICROCRÉDITO-RL' ? 14 : 9"
                      (pushDocumentacao)="pushDocumentacao()">

                      <div class="row">
                        <div class="col-xs-12" *ngIf="assinaturaDigital && !assinado">
                          <button
                          class="btn btn-full-orange mb15"
                          [disabled]="!alfabetizado"
                          (click)="abrirModalAssinatura()">Assinar Documentos</button>
                        </div>
                        <div class="col-xs-12" style="padding-bottom: 20px;">
                          <a class="button-link" (click)="verificarMudancaTipo()" *ngIf="!assinado">{{ assinaturaManual ? 'Alterar para Assinatura Digital' : 'Alterar para Assinatura Manual'}}</a>
                        </div>
                      </div>
                  </app-upload-arquivos>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
